import { useEffect, useMemo, useRef } from 'react';
import { useTrackEventsContextQuery } from 'remote-state/platformIntegrationServiceHooks';
import { useFeatureFlagQuery } from 'remote-state/featureFlagsHooks';
import { FEATURE_FLAGS_KEYS } from 'constants/featureFlags';
import { isObjectShallowEqual } from '../utils';
import { setGlobalContext } from '../datadogUtils';

export const useDatadogGlobalContext = (): void => {
  const { data: isCommonEventAttributesEnabled } = useFeatureFlagQuery({
    flagKey: FEATURE_FLAGS_KEYS.ENABLE_COMMON_EVENT_ATTRIBUTES,
    defaultValue: false,
  });
  const { data: trackEventsContext } = useTrackEventsContextQuery(!!isCommonEventAttributesEnabled);
  const lastContextRef = useRef<Record<string, any> | null>(null);

  const isObjectEqual = useMemo(() => isObjectShallowEqual(trackEventsContext, lastContextRef.current), [trackEventsContext]);

  useEffect(() => {
    const shouldUpdateContext =
      isCommonEventAttributesEnabled &&
      trackEventsContext &&
      (lastContextRef.current === null || !isObjectEqual);
    if (shouldUpdateContext) {
      setGlobalContext(trackEventsContext);
      lastContextRef.current = trackEventsContext;
    }
  }, [trackEventsContext, isCommonEventAttributesEnabled, isObjectEqual]);
}
